import { inject } from "mobx-react";
import React from "react";
import { CreateView, IndexView, ShowView } from "lego-gui-lib/lib";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  HuntingGroupMemberSchema,
  HuntingGroupMemberSchemaColumns
} from "./schema";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../../common/tabContainers";
import { toolbarButtonsWithSwitch } from "./toolbarButtonsWithSwitch";
import { customRowButtons } from "./customRowButtons";
import { TableBody } from "@material-ui/core";
import {
  withDraggable,
  withDroppable
} from "lego-gui-lib/lib/components/DragAndDrop/DragAndDrop";
import { DraggableDataTableRow } from "../../../common/customDataTableRows/DraggableDataTableRow";
import { isAllowed } from "../../../common/common";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router";

const injectDataSource = (comp: any) =>
  inject("huntingGroupMember", "i18n")(observer(comp));

export const IndexHuntingGroupMember = injectDataSource(
  ({ huntingGroupMember, i18n, match, ...rest }: any) => {
    const indexTitle = i18n.t("hns:huntingGroupMember:members");

    const onDnd = async (event: any, data: any) => {
      const { destination, source } = event;
      const destinationRow = data[destination.index];
      const sourceRow = data[source.index];
      huntingGroupMember.listDataSource.moveRow(sourceRow, {
        moveTo: destinationRow.position
      });
    };

    return (
      <IndexView
        dataSource={huntingGroupMember.listDataSource}
        {...rest}
        toolbarButtons={toolbarButtonsWithSwitch("isActive")}
        rowButtons={customRowButtons}
        fixedParams={{
          sort: {
            order: "asc",
            sort: "position"
          },
          filters: []
        }}
        title={indexTitle}
        columns={HuntingGroupMemberSchemaColumns}
        titleVariant={"h5"}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
        tableBodyComponent={withDroppable(onDnd, TableBody)}
        tableRowComponent={withDraggable(DraggableDataTableRow)}
      />
    );
  }
);

export const CreateHuntingGroupMember = injectDataSource(
  ({ huntingGroupMember, i18n, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:huntingGroupMember:domain"
    });
    const baseUrl = match.url;

    const id = {
      id: match.params.memberId
    };
    const history = useHistory();
    return (
      <>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <CreateView
          dataSource={huntingGroupMember.oneDataSource}
          {...rest}
          title={title}
          fields={HuntingGroupMemberSchemaColumns}
          id={id.id ? id : undefined}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);

export const ShowHuntingGroupMember = injectDataSource(
  ({ huntingGroupMember, i18n, match }: any) => {
    const allowed = isAllowed(huntingGroupMember);
    const title = allowed
      ? i18n.t("common:edit", { domain: "hns:huntingGroupMember:domain" })
      : i18n.t("hns:huntingGroupMember:domain");
    const baseUrl = match.url;
    const id = {
      id: match.params.memberId
    };
    const history = useHistory();
    return (
      <>
        <BreadcrumbsItem to={baseUrl}>{title}</BreadcrumbsItem>
        <ShowView
          dataSource={huntingGroupMember.oneDataSource}
          title={title}
          fields={HuntingGroupMemberSchema}
          id={id}
          goBack={() => history.goBack()}
        />
      </>
    );
  }
);
